import { compose, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import { closePayment } from '../reducer/currentPayment/actions';
import {
  getCashOptions,
  getChargeAmount,
} from '../reducer/chargeAmount/selectors';
import withAddPayment from '../hoc/withAddPayment';
import CashOptions from '../components/CashOptions';
import { PAYMENT_TYPE } from '../../../main/payment/constants';

const CashOptionsContainer = compose(
  withAddPayment,
  connect(
    state => ({
      chargeAmount: getChargeAmount(state),
      cashAmounts: getCashOptions(state),
    }),
    { closePayment }
  ),
  withState('paidAmount', 'setPaidAmount', 0),
  withState('changeAmount', 'setChangeAmount', 0),
  withHandlers({
    handleOptionSelect: props => amount => () => {
      props.setPaidAmount(amount);
      props.setChangeAmount(amount - props.chargeAmount);
    },
    charge: props => () => {
      props.addPayment({
        type: PAYMENT_TYPE.cash,
        amount: props.chargeAmount,
      }).then(props.closePayment);
    },
  }),
  withHandlers({
    handleCustom: props => amount => props.handleOptionSelect(amount)(),
  })
);

export default CashOptionsContainer(CashOptions);
